import { render, staticRenderFns } from "./InspectionForm.vue?vue&type=template&id=52d3f337&"
import script from "./InspectionForm.vue?vue&type=script&lang=js&"
export * from "./InspectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports